import React, { useEffect } from "react";

// @mui/material components
import { styled } from "@mui/system";
import GridItem from "../../components/Grid/GridItem.js";
import GridContainer from "../../components/Grid/GridContainer.js";
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import Button from '@mui/material/Button';
import { useSelector, useDispatch } from 'react-redux';
import { getActivePartrequests } from "../../reduxStore/entities/partrequests";
import { useNavigate } from "react-router-dom";

import Layout from "../../core/Layout";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    '&.MuiTableCell-head': {
        backgroundColor: theme.palette.common.black,
        color: theme.palette.common.white,
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
}));

const columns = [
    { id: 'part_request_id', label: 'ID', minWidth: 200 },
    { id: 'title', label: 'Title', minWidth: 200 },
    { id: 'description', label: 'Description', minWidth: 270 },
    { id: 'state', label: 'State', minWidth: 70 },
    { id: 'createdAt', label: 'CreatedAt', minWidth: 70 },
];

function createData(part_request_id, title, description, state, createdAt) {
    return { part_request_id, title, description, state, createdAt };
}

const useStyles = () => ({
    root: {
        padding: 20,
    },
    container: {
        maxHeight: 440,
    },
});

export default function ActiveRequests() {
    const styles = useStyles();

    const navigate = useNavigate();
    const partrequests = useSelector((state) => state.partrequests.activepartrequests);

    const handleTableLoad = (partrequests) => {
        const preparedData = partrequests.map(partrequest => {
            return createData(partrequest.part_request_id, partrequest.title, partrequest.description, partrequest.state, partrequest.createdAt);
        });
        return preparedData;
    };

    const dataLoaded = useSelector((state) => state.partrequests.activeDataLoaded);
    const dispatch = useDispatch();
    const [rows, setRows] = React.useState(handleTableLoad(partrequests));

    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };

    function handleClick(id) {
        navigate("/admin/requestcreateoffer/" + id);
    }

    useEffect(() => {
        const doasync = async () => {
            await dispatch(getActivePartrequests());
        };
        doasync();
    }, [dispatch]);

    useEffect(() => {
        setRows(handleTableLoad(partrequests));
    }, [partrequests, dataLoaded]);

    return (
        <Layout>
            <div>
                {dataLoaded ? (
                    <GridContainer>
                        <GridItem xs={12} sm={12} md={12}>
                            <Paper sx={styles.root} >
                                <TableContainer sx={styles.container}>
                                    <Table stickyHeader aria-label="sticky table">
                                        <TableHead>
                                            <TableRow>
                                                {columns.map((column) => (
                                                    <StyledTableCell
                                                        key={column.id}
                                                        align={column.align}
                                                        style={{ minWidth: column.minWidth }}
                                                    >
                                                        {column.label}
                                                    </StyledTableCell>
                                                ))}
                                                <StyledTableCell></StyledTableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => {
                                                return (
                                                    <StyledTableRow hover role="checkbox" tabIndex={-1} key={row.part_request_id}>
                                                        {columns.map((column) => {
                                                            const value = row[column.id];
                                                            return (
                                                                <StyledTableCell key={column.id} align={column.align}>
                                                                    {column.format && typeof value === 'number' ? column.format(value) : value}
                                                                </StyledTableCell>
                                                            );
                                                        })}
                                                        <StyledTableCell>
                                                            <Button variant="contained" onClick={() => handleClick(row.part_request_id)} >Details</Button>
                                                        </StyledTableCell>
                                                    </StyledTableRow>
                                                );
                                            })}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                                <TablePagination
                                    rowsPerPageOptions={[10, 25, 100]}
                                    component="div"
                                    count={rows.length}
                                    rowsPerPage={rowsPerPage}
                                    page={page}
                                    onChangePage={handleChangePage}
                                    onChangeRowsPerPage={handleChangeRowsPerPage}
                                />
                            </Paper>
                        </GridItem>
                    </GridContainer>
                )
                    : (
                        <div>Loading...</div>
                    )}
            </div>
        </Layout>
    );
}
